import PropTypes from "prop-types";
import clsx from "clsx";
import { Link, useParams } from "react-router-dom";

const Logo = ({ imageUrl, logoClass }) => {
  const customerCodeStore = useParams();
  const customerCode = customerCodeStore?.UserCode;
  return (
    <div className={clsx(logoClass)}>
      <Link to={`/${customerCode}`}>
        <img alt="" src={imageUrl} className="User_Logo" />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string,
};

export default Logo;
